import { Card, Illustration, Layout, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { AppFooterLinks } from "./app-footer/AppFooterLinks";
import { AppHeader } from "./app-header/AppHeader";

interface Props {
  title?: string;
  message: string;
}

export function ConfigurationError(props: Props) {
  const { t } = useTranslation();
  const { title = t("No access"), message } = props;

  return (
    <Layout layout="narrow" header={<AppHeader />} footer={<AppFooterLinks />}>
      <Card border="none" className={styles.card}>
        <Illustration name="no-results" />
        <Text style="global/heading-large" align="center">
          {title}
        </Text>
        <Text style="global/body-primary" align="center" color="text-weak">
          {message}
        </Text>
      </Card>
    </Layout>
  );
}

const styles = {
  card: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "var(--space-6)",
    gap: "var(--space-4)",
  }),
};
